import { jsx as _jsx } from "react/jsx-runtime";
import { s, b } from './common.js';
/**
 * Minimal markdown → HTML. Supports:
 *   # / ## / ### headings on their own line
 *   **bold** and *italic*
 *   [text](url) links
 *   blank lines as paragraph breaks
 *   single newlines as <br>
 * Anything beyond this falls through as escaped text.
 */
export function renderMarkdown(input) {
    const escaped = input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    const paras = escaped.split(/\n{2,}/).map((para) => {
        const trimmed = para.trim();
        if (!trimmed)
            return '';
        let headingMatch = /^###\s+(.+)$/.exec(trimmed);
        if (headingMatch)
            return `<h3>${inline(headingMatch[1])}</h3>`;
        headingMatch = /^##\s+(.+)$/.exec(trimmed);
        if (headingMatch)
            return `<h2>${inline(headingMatch[1])}</h2>`;
        headingMatch = /^#\s+(.+)$/.exec(trimmed);
        if (headingMatch)
            return `<h1>${inline(headingMatch[1])}</h1>`;
        return `<p>${inline(trimmed).replace(/\n/g, '<br>')}</p>`;
    });
    return paras.filter(Boolean).join('\n');
}
function inline(text) {
    return text
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_m, label, href) => `<a href="${href.replace(/"/g, '&quot;')}" target="_blank" rel="noopener noreferrer">${label}</a>`)
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\*([^*]+)\*/g, '<em>$1</em>');
}
export function MarkdownComponent(props) {
    const body = s(props.config, 'body');
    const allowHtml = b(props.config, 'allowHtml', false);
    const html = allowHtml ? body : renderMarkdown(body);
    return (_jsx("div", { className: "prose prose-sm max-w-none text-[var(--bcbb-text)]", dangerouslySetInnerHTML: { __html: html } }));
}
export const MarkdownArchetype = {
    name: 'Markdown',
    label: 'Markdown',
    description: 'Sanitized markdown body. Set `allowHtml=true` for raw HTML (DOMPurified by host).',
    component: MarkdownComponent,
    isFormArchetype: false,
    fields: {
        body: { kind: 'textarea', label: 'Body (markdown)' },
        allowHtml: {
            kind: 'checkbox',
            label: 'Treat body as raw HTML (sanitized)',
            defaultValue: false,
        },
    },
    defaultConfig: {
        body: '',
        allowHtml: false,
    },
};
